import { Box, Button, Flex, Image, Text } from "@chakra-ui/react"
import { DepositForAccount } from "@mezo/api"

import alertIcon from "#/assets/triangle-alert.svg"
import { useDepositBox } from "#/shared/hooks"

export default function DepositMigrationNotAvailable({
  selectedDeposit,
}: {
  selectedDeposit: DepositForAccount
}) {
  const { openBoostModal } = useDepositBox(selectedDeposit)

  return (
    <Box bg="#F7F6DB" borderRadius="16px">
      <Flex
        gap="20px"
        p="16px 28px"
        fontFamily="riforma.medium"
        fontWeight={500}
        lineHeight="24px"
        letterSpacing="0.16px"
        alignItems="flex-start"
      >
        <Image src={alertIcon} mt="4px" />
        <Flex flexDir="column">
          <Text color="#5C4F09" fontSize="18px">
            Migration not available.
          </Text>
          <Text color="#766C37" fontSize="16px">
            Deposit expiration date can&apos;t be sooner than Oct 31.
          </Text>
          <Button
            variant="primaryBlack"
            size="medium"
            mr="auto"
            mt="14px"
            color="primary.white.100"
            onClick={openBoostModal}
          >
            <Text variant="body">Extend deposit</Text>
          </Button>
        </Flex>
      </Flex>
    </Box>
  )
}
